const topSellingData = [
    {
        id: 601,
        name: "Burro's Tail",
        price: '49.99',
        type: 'Succulent & Cacti Houseplant',
        imageUrl: 'https://i.ibb.co/z7Bk34b/Burro-s-Tail.jpg',
        parentRoute: 'cacti',
    },
    {
        id: 702,
        name: 'Hoya Carnosa Tricolor',
        price: '14.99',
        type: 'Trailing Houseplant',
        imageUrl: 'https://i.ibb.co/fvLTbbm/Hoya.jpg',
        parentRoute: 'trailing',
    },
    {
        id: 301,
        name: 'Amaryllis',
        price: '28.49',
        type: 'Flowering Houseplant',
        imageUrl: 'https://i.ibb.co/nn62WyK/Amaryllis.jpg',
        parentRoute: 'flowering',
    },
    {
        id: 500,
        name: 'Asparagus Fern',
        price: '24.99',
        type: 'Small Houseplant',
        imageUrl: 'https://i.ibb.co/87Xh34G/Asparagus-Fern.jpg',
        parentRoute: 'small',
    },
];

export default topSellingData;
